export const MODIFY_FINAL_COLUMN_NAMES = 'MODIFY_FINAL_COLUMN_NAMES';

export function modifyFinalColumnNames(finalColumnNames){
    return{
        type: MODIFY_FINAL_COLUMN_NAMES,
        mainState: {
            finalColumnNames: finalColumnNames
        }
    }
}